<template>
  <el-card>
    <template #header>
      <content-header />
    </template>
    <div class="header-button" />
    <search-form
      ref="searchForm"
      :fields="search"
    />

    <el-table
      :data="questions"
      resource="worker"
    >
      <el-table-column
        prop="nickname"
        label="姓名"
      />
      <el-table-column
        prop="mobile"
        label="手机号"
      />

      <el-table-column
        prop="area_name"
        label="区域"
      />
      <el-table-column
        prop="location_name"
        :show-overflow-tooltip="true"
        label="地点"
      />

      <el-table-column
        label="是否审核"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.is_examine"
            type="success"
          >已审核</el-tag>
          <el-tag
            v-else
            type="danger"
          >未审核</el-tag>
        </template>
      </el-table-column>

      <el-table-column
        prop="created_at"
        label="添加时间"
        width="180"
      />
      <el-table-column
        label="操作"
        width="120"
      >
        <template #default="{ row, $index }">
          <el-button @click="detailClick(row,$index)"> 详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer">
      <pagination :page="page" />
    </div>
    <el-dialog
      title="位置详情"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <div
        class="amap-page-container"
        style="width: 100%!important; height:400px;"
      >
        <el-amap
          ref="map"
          vid="amapDemo"
          :amap-manager="amapManager"
          :center="center"
          :zoom="zoom"
          :plugin="plugin"
          :events="events"
          class="amap-demoo"
        >
          <el-amap-marker
            :position="markerBikePosition.position"
            :events="markerBikePosition.events"
            :visible="markerBikePosition.visible"
            :draggable="markerBikePosition.draggable"
            :animation="markerBikePosition.animation"
          />
        </el-amap>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogVisible = false">取 消</el-button>
        <!-- <el-button type="primary" @click="dialogVisible = false">确 定</el-button> -->
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import SearchForm from "@c/SearchForm";
import Pagination from "@c/Pagination";
import { getApplyAddParkings } from "@/api/parking";
import { getAreas } from "@/api/area";
import VueAMap from "vue-amap";
import { mixinsAutoPageSize } from "@/libs/utils";
import { getAdminUsersMerchant } from "@/api/admin-merchant";
import env from "../../env";
export default {
  name: "Index",
  components: {
    SearchForm,
    Pagination
  },
  data() {
    let amapManager = new VueAMap.AMapManager();
    return {
      search: [
        {
          type: "el-select",
          field: "area_id",
          label: "骑行区域",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        },
        {
          type: "el-select",
          field: "is_examine",
          label: "是否审核",
          options: [
            {
              id: "",
              name: "全部"
            },
            {
              id: 0,
              name: "未读"
            },
            {
              id: 1,
              name: "已读"
            }
          ]
        }
      ],
      questions: [],
      amapManager: amapManager,
      page: null,
      first_blood: true,
      areas: [],
      dialogVisible: false,
      center: [121.59996, 31.197646],
      zoom: 12,
      markerBikePosition: {
        position: [121.5273285, 31.21515044],
        events: {
          click: () => {
            // alert('click marker')
          }
        },
        visible: true,
        draggable: false,
        animation: "AMAP_ANIMATION_DROP"
      },
      plugin: [
        {
          pName: "MapType",
          defaultType: 0,
          events: {
            init(o) {
              // console.log(o)
            }
          }
        },
        {
          pName: "Geolocation",
          events: {
            init(o) {
              // o 是高德地图定位插件实例
              // console.log(o)
              o.getCurrentPosition((status, result) => {
                // 未配置https  定位失败 暂时手动配置
                self.lng = 113.73350255780726;
                self.lat = 34.78024666564106;
                // self.center = [self.lng, self.lat]
                self.loaded = true;
                if (result && result.position) {
                  self.lng = result.position.lng;
                  self.lat = result.position.lat;
                  self.center = [self.lng, self.lat];
                  self.loaded = true;
                  // self.$nextTick()
                }
              });
            }
          }
        },
        {
          pName: "Scale",
          // offset: { x: 20, y: 20 },
          position: "RB",
          events: {
            init(instance) {
              // console.log(instance)
            }
          }
        },
        {
          pName: "ToolBar",
          events: {
            init(instance) {
              // console.log(instance)
            }
          }
        }
      ],
      events: {
        init(o) {}
      }
    };
  },
  inject: ["reload"],
  mixins: [mixinsAutoPageSize],
  watch: {
    $route: {
      async handler(newVal) {
        await this.autoPageSize(53, newVal);
        const {
          data: { data, meta }
        } = await getApplyAddParkings(newVal.query);
        this.questions = data;
        this.page = meta;
      },
      immediate: true
    }
  },
  async created() {
    // console.log(11)

    const [{ data: areas }] = await Promise.all([getAreas({ all: 1 })]);

    this.areas.push.apply(this.areas, areas);
    this.search[0].options.push.apply(this.search[0].options, areas);
    if (this.$store.state.users.user.roles[0] === "administrator") {
      const [{ data: merchant }] = await Promise.all([
        getAdminUsersMerchant({ all: 1 })
      ]);
      if (env.isPosSwitch == true) {
        this.search.push({
          type: "el-select",
          field: "merchant_id",
          label: "商户",
          options: [
            {
              id: "",
              name: "全部"
            }
          ]
        });
        this.search[2].options.push.apply(
          this.search[2].options,
          merchant.data
        );
      }
    }
  },
  methods: {
    async detailClick(row, index) {
      console.log(row);
      this.markerBikePosition.position = [row.longitude, row.latitude];
      this.center = [row.longitude, row.latitude];
      this.dialogVisible = true;

      // this.detailQuestion = row.question
      // if (row.is_read === 0) {
      //   await isReadChange({ id: row.id }).then(res => {
      //     res.then(data => {
      //       this.questions[index].is_read = 1
      //     })
      //   })
      // }
    }
  }
};
</script>
<style lang="scss" scope>
.header-button {
  display: flex;
  justify-content: space-between;
  .selections {
    display: inline-block;
    margin-right: 10px;
  }
}
.limitwidth {
  width: 40%;
  margin-right: 10px;
}
</style>
